import React from 'react';
import { Ads } from '../../../../ads/components';
import { Card } from '../../../../common/components/card';
import { LeftNavigation } from './left-navigation';

type Props = {
	children: React.ReactNode;
};

export const DocsLayout: React.FC<Props> = ({children}) => (
	<React.Fragment>
		<Ads />
		<Card>
			<div className="grid grid-cols-1 md:grid-cols-4">
				<LeftNavigation />
				<div className="px-4 col-span-3 pb-8">
					{children}
				</div>
			</div>
		</Card>
	</React.Fragment>
);